import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { DepositApi } from "../lib/api/DepositApi";

const DepositByUserLayer = () => {
  const { id } = useParams();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  // ⏱ Default: 4 hari lalu dan besok
  const now = new Date();
  const defaultFirstDate = new Date(now);
  defaultFirstDate.setDate(now.getDate() - 2);

  const defaultEndDate = new Date(now);
  defaultEndDate.setDate(now.getDate() + 1);

  const formatDateTime = (date) => {
    return date.toISOString().slice(0, 19).replace("T", " ");
  };

  const [firstDate, setFirstDate] = useState(formatDateTime(defaultFirstDate));
  const [endDate, setEndDate] = useState(formatDateTime(defaultEndDate));

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const response = await DepositApi.index(firstDate, endDate, id);

        // console.log(response.data);

        setTransactions(response.data); // atau sesuaikan dengan struktur responsmu
        setLoading(false);
      } catch (error) {
        setErrorMsg("Gagal mengambil data sales.");
        setLoading(false);
      }
    };

    fetchSales();
  }, [firstDate, endDate]);

  const formatCurrency = (value) => {
    if (value === null || value === undefined) {
      return "-";
    }
    const numberValue = parseFloat(value);
    if (isNaN(numberValue)) {
      return "-";
    }
    return numberValue.toLocaleString("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="card">
      <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">
        <div className="d-flex flex-wrap align-items-center gap-3">
          <input
            type="date"
            className="form-control form-control-sm w-auto"
            value={firstDate.slice(0, 10)}
            onChange={(e) => setFirstDate(e.target.value + " 00:00:00")}
          />
          <span className="mx-2">to</span>
          <input
            type="date"
            className="form-control form-control-sm w-auto"
            value={endDate.slice(0, 10)}
            onChange={(e) => setEndDate(e.target.value + " 23:59:59")}
          />
          <button
            className="btn btn-primary btn-sm"
            onClick={() => {
              setFirstDate(formatDateTime(defaultFirstDate));
              setEndDate(formatDateTime(defaultEndDate));
            }}
          >
            Reset
          </button>
        </div>
        <div className="d-flex flex-wrap align-items-center gap-3">
          <select
            className="form-select form-select-sm w-auto"
            defaultValue="Select Status"
          >
            <option value="Select Status" disabled>
              Select Status
            </option>
            <option value="Paid">Paid</option>
            <option value="Pending">Pending</option>
          </select>
        </div>
      </div>
      <div className="card-body">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table mb-0">
            <thead>
              <tr>
                <th scope="col">
                  <div className="form-check style-check d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultValue=""
                      id="checkAll"
                    />
                    <label className="form-check-label" htmlFor="checkAll">
                      S.L
                    </label>
                  </div>
                </th>
                <th scope="col">Date</th>
                <th scope="col">Status</th>
                {/* <th scope="col">Provider name</th> */}
                <th scope="col">User Out</th>
                <th scope="col">Amount</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction, index) => (
                <tr key={index}>
                  <td>
                    <div className="form-check style-check d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        defaultValue=""
                        id={`check${index}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`check${index}`}
                      >
                        {transaction.id}
                      </label>
                    </div>
                  </td>
                  <td>
                    <Link to="#" className="text-primary-600">
                      {transaction.date}
                    </Link>
                  </td>
                  <td>
                    {" "}
                    <span
                      className={`bg-${
                        transaction.status === "settlement"
                          ? "success-focus text-success-main"
                          : transaction.status === "pending"
                          ? "secondary-focus text-secondary-main"
                          : "danger-focus text-danger-main"
                      } px-24 py-4 rounded-pill fw-medium text-sm`}
                    >
                      {transaction.status}
                    </span>
                  </td>
                  {/* <td>
                    <div className="d-flex align-items-center">
                      <h6 className="text-md mb-0 fw-medium flex-grow-1">
                        {transaction.provider_name}
                      </h6>
                    </div>
                  </td> */}
                  <td>{transaction.user_out_name}</td>
                  <td className="text-end">
                    {formatCurrency(transaction.amount)}
                  </td>

                  <td>
                    <Link
                      to={`/deposit/${transaction.id}`}
                      className="w-32-px h-32-px  me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                      <Icon icon="iconamoon:eye-light" />
                    </Link>
                    <Link
                      to="#"
                      className="w-32-px h-32-px  me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                      <Icon icon="lucide:edit" />
                    </Link>
                    <Link
                      to="#"
                      className="w-32-px h-32-px  me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                      <Icon icon="mingcute:delete-2-line" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
            <span>Showing 1 to 10 of 12 entries</span>
            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
              <li className="page-item">
                <Link
                  className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px  me-8 w-32-px bg-base"
                  to="#"
                >
                  <Icon icon="ep:d-arrow-left" className="text-xl" />
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link bg-primary-600 text-white fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px  me-8 w-32-px"
                  to="#"
                >
                  1
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link bg-primary-50 text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px  me-8 w-32-px"
                  to="#"
                >
                  2
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link bg-primary-50 text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px  me-8 w-32-px"
                  to="#"
                >
                  3
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px  me-8 w-32-px bg-base"
                  to="#"
                >
                  {" "}
                  <Icon icon="ep:d-arrow-right" className="text-xl" />{" "}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositByUserLayer;
